module.exports = __webpack_public_path__ + "img/about_8.cb261544.png";